import styles from "../styles.module.css";

export default function DayTypeTitle({ label }) {
  return (
    <div className={styles.dialogDayTypeTitleContainer}>
      <div className={styles.dialogDayTypeTitle}>{label}</div>
    </div>
  );
}
